import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-portfolio',
  templateUrl: './logo-portfolio.component.html',
  styleUrls: ['./logo-portfolio.component.scss']
})
export class LogoPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
